export const invoiceTemplates = {
  actions: {
    create: 'Factuurtemplate aanmaken',
    createInvoice: 'Factuur aanmaken',
    delete: 'Verwijderen',
    details: 'Meer details',
    edit: 'Bewerken',
    pause: 'Pauzeren',
    unpause: 'Live zetten',
  },
  alerts: {
    successCreated: 'Je factuurtemplate is aangemaakt.',
    successDeleted: 'Je factuurtemplate is verwijderd.',
    successUpdated: 'Je factuurtemplate is bewerkt.',
  },
  breadcrumb: {
    create: 'Factuurtemplate aanmaken',
    noTitle: 'Geen titel',
    overview: 'Factuurtemplates',
  },
  breadcrumbs: {
    index: 'Alle factuurtemplates',
    show: 'Factuurtemplate details',
  },
  createEdit: {
    blocker: {
      create: 'Ben je zeker dat je de pagina wilt verlaten? Je factuurtemplate is niet opgeslagen.',
      edit: 'Ben je zeker dat je de pagina wilt verlaten? Je wijzigingen zijn niet opgeslagen.',
    },
    fields: {
      interval: {
        label: 'Periodiek aanmaken',
      },
      nextInvoiceAt: {
        label: 'Eerstvolgende factuur',
      },
      paymentTerm: {
        helpText: 'De vervaldatum zal {{days}} dagen na de factuurdatum zijn.',
        helpTextEndOfMonth: 'De vervaldatum zal {{days}} dagen na het einde van de maand van de factuurdatum zijn.',
      },
    },
    header: {
      title: {
        create: 'Nieuwe factuurtemplate',
        edit: 'Bewerk factuurtemplate',
      },
    },
    preview: 'Voorbeeld factuur',
    unpauseModal: {
      description:
        'Je factuurtemplate is niet actief.\n<break/>Opnieuw activeren? De volgende factuur wordt aangemaakt op {{nextInvoiceAt}}.',
      keepPaused: 'Inactief laten',
      title: 'Periodieke facturen hervatten',
      unpause: 'Opnieuw activeren',
    },
  },
  deleteModal: {
    description: 'Ben je zeker dat je deze factuurtemplate wilt verwijderen?',
    submit: 'Verwijder factuurtemplate',
    title: 'Factuurtemplate verwijderen',
  },
  details: {
    error: {
      title: 'Fout bij het laden van je factuurtemplate.',
    },
    intervalStatusTooltip: {
      Live: 'Je factuurtemplate is actief, facturen worden periodiek aangemaakt.',
      Paused: 'Je factuurtemplate is niet actief, je facturen worden niet periodiek aangemaakt.',
    },
    invoices: {
      noInvoicesMessage: 'Er zijn nog geen facturen aangemaakt met deze factuurtemplate.',
      title: 'Facturen',
      titleWithCount: 'Facturen ({{amount}})',
    },
    stats: {
      nextInvoice: {
        label: 'Volgende factuur',
        tooltip: 'Op deze dag wordt er automatisch een nieuwe conceptfactuur voor je aangemaakt, op basis van deze template.',
      },
      recurring: {
        label: 'Periodiek aanmaken',
        tooltip: 'Hoe vaak je facturen worden aangemaakt.',
      },
      totalAdvantage: {
        label: 'Totaal voordeel',
        tooltip: 'Het totale voordeel van alle facturen die je gemaakt hebt met deze template.',
      },
      totalInvoices: {
        label: 'Aantal facturen',
        tooltip: 'Totaal aantal periodieke facturen aangemaakt met deze template.',
      },
    },
    summary: {
      title: 'Overzicht',
    },
  },
  overview: {
    columns: {
      client: 'Klant',
      nextInvoiceAt: 'Volgende factuur',
      title: 'Titel',
      total: 'Totaal (excl. btw)',
      type: 'Type',
    },
    error: {
      title: 'Fout bij het laden van je factuurtemplates.',
    },
    header: {
      title: 'Factuurtemplates',
    },
  },
  terminology: {
    interval: {
      cases: {
        Disabled: 'Uitgeschakeld',
        Monthly: 'Maandelijks',
        Quarterly: 'Elk kwartaal',
        Weekly: 'Wekelijks',
      },
    },
    intervalStatus: {
      cases: {
        Live: 'Live',
        Paused: 'Pauze',
      },
    },
    invoiceTemplate: 'Factuurtemplate',
    templateType: {
      cases: {
        Manual: 'Manueel',
        Recurring: 'Periodiek',
      },
    },
  },
};
